export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function safeJsonParse(raw: string): unknown {
  return JSON.parse(raw);
}

export function safeJsonParseRecord(raw: string): Record<string, unknown> | null {
  try {
    const parsed = safeJsonParse(raw);
    return isRecord(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function safeJsonParseStringArray(raw: string | null | undefined): string[] {
  if (!raw) return [];
  try {
    const parsed = safeJsonParse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((value): value is string => typeof value === 'string');
  } catch {
    return [];
  }
}
